import { Component, Input } from "@angular/core";
import { BaseEntityResponse, BaseState, Notification } from '@base/entities/BaseEntities';
import { BasePageComponent } from '@base/component/BasePageComponent';
import { ServiceBagService, ServiceBagServices } from '@base/component/ServiceBag';
import { EnumNotificationDeliveryOptions, EnumNotificationStatuses, EnumPageDisplayModes, EnumWindowSizes } from "@m4u-angular/core/framework/sysenums.enum";
import { NotificationEndpoint } from "@m4u-angular/core/endpoints/notification.endpoint";
import { DomSanitizer } from '@angular/platform-browser';

class State extends BaseState {
    WindowWidth: EnumWindowSizes;
}

@Component({
    providers: ServiceBagServices,
    selector: 'm4u-notificationview',
    templateUrl: './notificationview.component.html',
    styleUrls: ['./notificationview.component.scss']
})
export class NotificationViewComponent extends BasePageComponent<Notification, State>
{
    constructor(A: ServiceBagService, private notificationEndpoint: NotificationEndpoint, public sanitizer: DomSanitizer) {
        super(A, 'NotificationViewComponent', Notification, State, EnumPageDisplayModes.Window);
    }

    override OnInitComponent() {
        this.State.WindowWidth = this.QueryParams.WindowWidth ? this.QueryParams.WindowWidth : EnumWindowSizes.WindowMedium;
        const entryID = this.A.Navigator.GetRouteParams().EntryID;
        this.SetEntity(Notification, this.notificationEndpoint.Get(entryID), false, (response: BaseEntityResponse<Notification>) => {});
    }

    GetStatusColor() {
        switch(this.Entity.Status) {
            case EnumNotificationStatuses.Sent:
                return 'green-cyan';
            case EnumNotificationStatuses.Failure:
                return 'cinnabar';
            case EnumNotificationStatuses.Sending:
                return 'atomic-tangerine';
            case EnumNotificationStatuses.Draft:
                return 'portage';
        }
    }
}
